import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Typography,
  useTheme,
  IconButton,
  Box,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { useAuth } from "../../Context/AuthContext";
import { LOGIN_MUTATION } from "../../Pages/LoginPage";
import CloseIcon from "@mui/icons-material/Close";

const LoginDialog = ({ open, onClose, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [login, { loading, error }] = useMutation(LOGIN_MUTATION);
  const { setAuth } = useAuth();
  const theme = useTheme();

  const handleLogin = async () => {
    try {
      const { data } = await login({ variables: { email, password } });
      if (data && data.login) {
        localStorage.setItem("autoChef_authToken", data.login);
        setAuth(true);
        onLoginSuccess(); // Continue the pending action
        onClose();
      }
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          backdropFilter: "blur(10px)",
          borderRadius: 2,
          boxShadow: theme.shadows[5],
          padding: 2,
        },
      }}
      maxWidth="xs"
      fullWidth
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
      >
        <DialogTitle>Login</DialogTitle>
        <IconButton color="error" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
        />
        {error && (
          <Typography color="error" variant="body2">
            Invalid credentials. Please try again.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleLogin} color="warning" disabled={loading}>
          {loading ? (
            <CircularProgress variant="determinate" color="success" size={24} />
          ) : (
            "Login"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginDialog;
